export const PRODUCT_ITEM_SEARCH = 'product/search'
